import React from "react";
import { useLocation } from "react-router-dom";

export default function Introduction({ handleInputChange, contract }) {
  const { pathname } = useLocation();
  return (
    <>
      <div className="carousel-item">
        <div className="mt-5 pt-4">
          <form className="container">
            <h3 className="mb-3">بيانات العقد</h3>
            <div className="row">
              <div className="col-12">
                <div className="mb-3">
                  <label htmlFor="introduction" className="form-label">
                    تمهيد
                  </label>
                  <textarea className="form-control" id="introduction" onChange={handleInputChange} rows={5} value={pathname === "/addContract" ? contract?.introduction : contract?.introduction || ""} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="first_party" className="form-label">
                    تعريف الطرف الاول{" "}
                  </label>
                  <input type="text" className="form-control" id="first_party" onChange={handleInputChange} value={contract.first_party} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="second_party" className="form-label">
                    تعريف الطرف التاني
                  </label>
                  <input type="text" className="form-control" id="second_party" onChange={handleInputChange} value={contract.second_party} />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="d-flex justify-content-between mx-5 my-3">
          <div>
            <button className="btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
              <span>السابق</span>
            </button>
          </div>
          <div>
            <button className={`btn btn-primary ${contract.start_date === "" || contract.end_date === "" || contract.maintenance_visits === null ? "d-none" : ""}`} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
              التالي
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
